


document.querySelectorAll('.navbar__collapsible').forEach(function (element) {
    element.addEventListener('click', function () {
        this.parentElement.classList.toggle('navbar--expanded');
    });
    }
);